/* PREVIEW (2026-10-19): "Compare similar models" for sections/fl-preview-compare.liquid.
   Loads assets/fl-compare-<category>.json, fills the model pickers and opens an accessible modal
   (role="dialog", aria-modal, focus trap, Esc / backdrop / X to close) with a side by side spec table.
   v2 (2026-10-20): a value a model does not list is a blank cell (no dash); a row no compared model lists is hidden.
   A product that is not in the data yet (section rendered with data-flc-fallback) gets its specs from the rows the
   section parsed from its description, mapped to the group's keys through each key's aliases; the block stays hidden
   unless at least 2 keys besides warranty match. */
(function () {
  'use strict';
  if (window.__flCompare) return;
  window.__flCompare = true;

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // Live prices are shown as the store formats them: the shop money format ({{ shop.money_format }}), same output
  // as the Liquid money filter used for this product's own price.
  var moneyFormat = '${{amount}}';
  var money = function (cents) {
    var n = Math.round(Number(cents) || 0);
    var group = function (d, sep, dec) {
      var v = (n / 100).toFixed(d).split('.');
      return v[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (v[1] ? dec + v[1] : '');
    };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return group(0, ',', '.');
        case 'amount_with_comma_separator': return group(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(2, "'", '.');
        case 'amount_with_space_separator': return group(2, ' ', ',');
        default: return group(2, ',', '.');
      }
    });
  };
  var imgUrl = function (u, w) {
    if (!u) return '';
    try { var x = new URL(u, location.href); if (/cdn\.shopify\.com|\/cdn\/shop\//.test(x.href)) x.searchParams.set('width', w); return x.href; } catch (e) { return u; }
  };
  var normLabel = function (s) { return String(s || '').toLowerCase().replace(/[.\-‐‑‒–—_\/():,#*'"″′]+/g, ' ').replace(/\s+/g, ' ').trim(); };
  var UNIT_WORDS = /\s+\b(?:lb|lbs|inches|inch|in|psi|cfm|ft lb|nm|kg|mm|cm|l min|v|hp|sec|s)\b\s*$/;
  var same = function (v) { return String(v || '').toLowerCase().replace(/[″”“]/g, '"').replace(/[′’]/g, "'").replace(/\s+/g, ''); };
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  var liveCache = {};
  function live(handle) {
    if (!liveCache[handle]) {
      liveCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return liveCache[handle];
  }

  function init(el) {
    var cur = {};
    try { cur = JSON.parse(el.querySelector('[data-flc-current]').textContent); } catch (e) {}
    if (cur.money_format) moneyFormat = cur.money_format;
    var selects = [].slice.call(el.querySelectorAll('[data-flc-select]'));
    var openBtn = el.querySelector('[data-flc-open]');
    var status = el.querySelector('[data-flc-status]');
    var data = null, byHandle = {}, modal = null, lastFocus = null, inerted = [];

    fetch(el.getAttribute('data-src'))
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        data = d;
        d.products.forEach(function (p) { byHandle[p.handle] = p; });
        if (el.hasAttribute('data-flc-fallback') && !byHandle[cur.handle]) {
          // new product: map its description rows to this group's keys
          var alias = {};
          d.keys.forEach(function (k) { (k.aliases || []).forEach(function (a) { alias[a] = k.key; }); });
          cur.specs = {};
          (cur.rows || []).forEach(function (r) {
            var n = normLabel(r[0]), k = alias[n] || alias[n.replace(UNIT_WORDS, '').trim()];
            if (k && !cur.specs[k] && r[1]) cur.specs[k] = String(r[1]).replace(/\s+/g, ' ').trim();
          });
          var hits = Object.keys(cur.specs).filter(function (k) { return k !== 'warranty'; }).length;
          if (hits < 2) return; // not enough comparable specs: the block stays hidden
          el.hidden = false;
        }
        var me = byHandle[cur.handle];
        var order = (me && me.related ? me.related.slice() : []);
        d.products.slice().sort(function (a, b) { return a.title.localeCompare(b.title); }).forEach(function (p) {
          if (p.handle !== cur.handle && order.indexOf(p.handle) < 0) order.push(p.handle);
        });
        order = order.filter(function (h) { return byHandle[h]; });
        if (!order.length) { status.textContent = 'No other models to compare in this category yet.'; return; }
        selects.forEach(function (s, i) {
          var optional = s.hasAttribute('data-optional');
          s.innerHTML = (optional ? '<option value="">None</option>' : '') + order.map(function (h) {
            return '<option value="' + esc(h) + '">' + esc(byHandle[h].title) + '</option>';
          }).join('');
          s.value = optional ? '' : order[0];
          s.disabled = false;
          s.addEventListener('change', sync);
        });
        sync();
      })
      .catch(function () { status.textContent = 'The comparison could not be loaded. Please refresh the page.'; });

    // A model can only be picked once: disable it in the other picker(s).
    function sync() {
      var picked = selects.map(function (s) { return s.value; });
      selects.forEach(function (s, i) {
        [].forEach.call(s.options, function (o) {
          o.disabled = !!o.value && picked.some(function (v, j) { return j !== i && v === o.value; });
        });
      });
      openBtn.disabled = !picked.some(Boolean);
    }

    openBtn.addEventListener('click', function () { open(); });

    // Prices: this product's come from Liquid; every other column waits for /products/<handle>.js (no stored prices).
    function column(p, isCurrent) {
      var j = byHandle[p.handle] || (isCurrent && p.specs ? { specs: p.specs } : {});
      return {
        handle: p.handle, current: isCurrent, title: p.title || j.title, url: p.url || j.url, image: p.image || j.image,
        price_text: isCurrent ? p.price_text : null, compare_text: isCurrent ? p.compare_text : null,
        available: isCurrent ? p.available : null, pending: !isCurrent, specs: j.specs || {}
      };
    }
    function livePrice(c, p) {
      var v = null;
      (p.variants || []).some(function (x) { if (x.available) { v = x; return true; } return false; });
      v = v || (p.variants || [])[0] || {};
      c.pending = false;
      if (p.price_varies) { c.price_text = 'From ' + money(p.price_min); c.compare_text = null; }
      else { c.price_text = money(v.price != null ? v.price : p.price); c.compare_text = v.compare_at_price > v.price ? money(v.compare_at_price) : null; }
      c.available = p.available;
    }

    function open() {
      var cols = [column(cur, true)];
      selects.forEach(function (s) { if (s.value && byHandle[s.value]) cols.push(column(byHandle[s.value], false)); });
      if (cols.length < 2) return;
      lastFocus = document.activeElement;
      if (!modal) modal = buildModal();
      render(cols);
      modal.root.hidden = false;
      document.documentElement.classList.add('flc-lock');
      [].forEach.call(document.body.children, function (c) {
        if (c !== modal.root && !c.inert && c.tagName !== 'SCRIPT') { c.inert = true; inerted.push(c); }
      });
      requestAnimationFrame(function () { modal.root.classList.add('is-open'); modal.panel.focus(); });
      // Price and availability of the other models come only from the live product JSON.
      cols.forEach(function (c, i) {
        if (c.current) return;
        live(c.handle).then(function (p) {
          if (modal.root.hidden) return;
          var cell = modal.table.querySelector('[data-col="' + i + '"]');
          if (!cell || cell.getAttribute('data-handle') !== c.handle) return;
          if (p) { livePrice(c, p); if (p.featured_image && !c.image) c.image = p.featured_image; }
          else { c.pending = false; c.failed = true; }
          // Only the price line and the image box change (they hold no focusable element).
          var tmp = document.createElement('th'); tmp.innerHTML = headCell(c);
          ['.flc-col__price', '.flc-col__img'].forEach(function (sel) {
            var a = cell.querySelector(sel), b = tmp.querySelector(sel);
            if (a && b && a.innerHTML !== b.innerHTML) a.innerHTML = b.innerHTML;
          });
        });
      });
    }

    function close() {
      if (!modal || modal.root.hidden) return;
      modal.root.classList.remove('is-open');
      inerted.forEach(function (c) { c.inert = false; });
      inerted = [];
      document.documentElement.classList.remove('flc-lock');
      modal.root.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function buildModal() {
      var id = el.id + '-dlg';
      var r = document.createElement('div');
      r.className = 'flc-modal';
      r.hidden = true;
      r.innerHTML =
        '<div class="flc-modal__backdrop" data-flc-close></div>' +
        '<div class="flc-modal__panel" role="dialog" aria-modal="true" aria-labelledby="' + id + '-t" tabindex="-1">' +
          '<div class="flc-modal__head">' +
            '<div class="flc-modal__titles"><p class="flc-modal__eyebrow">' + esc(data.title) + '</p>' +
            '<h2 class="flc-modal__title" id="' + id + '-t">Compare models</h2></div>' +
            '<label class="flc-switch"><input type="checkbox" role="switch" data-flc-diff><span class="flc-switch__track" aria-hidden="true"></span><span class="flc-switch__text">Show only differences</span></label>' +
            '<button type="button" class="flc-modal__x" data-flc-close aria-label="Close comparison">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
          '</div>' +
          '<div class="flc-modal__body">' +
            '<div class="flc-scroll" tabindex="0" role="region" aria-label="Comparison table, scroll sideways to see every model"><table class="flc-table"></table></div>' +
            '<p class="flc-modal__empty" hidden>Every listed spec is the same for these models.</p>' +
            '<p class="flc-modal__note">Specs are taken from each product description. A blank cell means the value is not listed.</p>' +
          '</div>' +
        '</div>';
      document.body.appendChild(r);
      var m = { root: r, panel: r.querySelector('.flc-modal__panel'), table: r.querySelector('.flc-table'), diff: r.querySelector('[data-flc-diff]'), empty: r.querySelector('.flc-modal__empty') };
      r.addEventListener('click', function (e) { if (e.target.closest('[data-flc-close]')) close(); });
      m.diff.addEventListener('change', applyDiff);
      r.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
        if (e.key !== 'Tab') return;
        var f = [].filter.call(m.panel.querySelectorAll(FOCUSABLE), function (n) { return n.offsetParent !== null || n === document.activeElement; });
        if (!f.length) { e.preventDefault(); return; }
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === m.panel)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      // Keep focus inside if it escapes (e.g. a click on the page behind in browsers without inert).
      document.addEventListener('focusin', function (e) { if (!r.hidden && !m.panel.contains(e.target)) m.panel.focus(); });
      return m;
    }

    function headCell(c) {
      var price = c.pending ? '<span class="flc-col__wait" style="font-weight:500;color:#64748b">Loading price</span>' : c.failed ? '<span class="flc-col__wait" style="font-weight:500;color:#64748b">See product page for price</span>' : esc(c.price_text || '');
      var was = c.compare_text ? ' <s class="flc-col__was">' + esc(c.compare_text) + '</s>' : '';
      return (c.current ? '<span class="flc-col__tag">This model</span>' : '<span class="flc-col__tag flc-col__tag--ghost" aria-hidden="true">&nbsp;</span>') +
        '<div class="flc-col__img">' + (c.image ? '<img src="' + esc(imgUrl(c.image, 360)) + '" alt="" loading="lazy" width="180" height="180">' : '') + '</div>' +
        '<a class="flc-col__title" href="' + esc(c.url) + '">' + esc(c.title) + '</a>' +
        '<p class="flc-col__price" aria-live="polite">' + price + was + (c.available === false ? ' <span class="flc-col__oos">Sold out</span>' : '') + '</p>' +
        '<a class="flc-col__link" href="' + esc(c.url) + '"' + (c.current ? ' aria-current="page"' : '') + '>View product<span class="visually-hidden">: ' + esc(c.title) + '</span>' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
    }

    function render(cols) {
      var t = modal.table;
      t.style.setProperty('--flc-cols', cols.length);
      var html = '<caption class="visually-hidden">Specs for ' + esc(cols.map(function (c) { return c.title; }).join(', ')) + '</caption>';
      html += '<thead><tr><td class="flc-table__corner"></td>' + cols.map(function (c, i) {
        return '<th scope="col" class="flc-col' + (c.current ? ' flc-col--current' : '') + '" data-col="' + i + '" data-handle="' + esc(c.handle) + '">' + headCell(c) + '</th>';
      }).join('') + '</tr></thead><tbody>';
      var rows = 0;
      data.keys.forEach(function (k) {
        var vals = cols.map(function (c) { return c.specs[k.key] || ''; });
        if (!vals.some(Boolean)) return; // nothing listed for any model
        var isSame = vals.every(function (v) { return v && same(v) === same(vals[0]); });
        rows++;
        html += '<tr data-same="' + (isSame ? 1 : 0) + '"><th scope="row">' + esc(k.label) + '</th>' + vals.map(function (v, i) {
          return '<td' + (cols[i].current ? ' class="is-current"' : '') + '>' + (v ? esc(v) : '<span class="visually-hidden">Not listed</span>') + '</td>';
        }).join('') + '</tr>';
      });
      if (!rows) html += '<tr><td colspan="' + (cols.length + 1) + '" class="flc-table__none">No specs are listed for these models yet.</td></tr>';
      t.innerHTML = html + '</tbody>';
      modal.root.querySelector('.flc-scroll').scrollLeft = 0;
      modal.root.querySelector('.flc-modal__body').scrollTop = 0;
      applyDiff();
    }

    function applyDiff() {
      var on = modal.diff.checked;
      modal.table.classList.toggle('is-diff', on);
      var rows = modal.table.querySelectorAll('tbody tr[data-same]');
      var visible = [].filter.call(rows, function (r) { return !on || r.getAttribute('data-same') === '0'; }).length;
      modal.empty.hidden = !(on && rows.length && !visible);
    }
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-flc]'), function (el) { if (!el.__flc) { el.__flc = 1; init(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
